import { createFeatureSelector, createSelector } from '@ngrx/store';
import { EventsState } from '../reducers/events.reducer';
import { EVENTS_FEATURE_KEY } from '../keys';

const selectState = createFeatureSelector<EventsState>(EVENTS_FEATURE_KEY);
export const selectEvents = createSelector(selectState, (state: EventsState) => state.events);
export const selectLoading = createSelector(selectState, (state: EventsState) => state.loading);
export const selectLoaded = createSelector(selectState, (state: EventsState) => state.loaded);
